import styled from 'styled-components';
import { key } from 'styled-theme';
import { media } from '@sizeid/commons/utils/styles';

export default styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  color: ${key('colors.black.light.400')};
  text-align: left;

  strong {
    color: ${key('colors.black.default')};
    display: block;
    padding-bottom: 5px;
  }

  img {
    display: block;
    width: 72px;
    height: 72px;
    flex: 0 0 72px;
    margin-right: 16px;
    border-radius: 50%;
  }

  ${media.lessThan('sm')`
    flex-direction: column;
    text-align: center;
    font-size: inherit;

    img {
      margin: 0 0 12px;
    }
  `};
`;
